import type { AppConfig } from './config';

export const config: AppConfig = {
    FRUITFUL_ENV: process.env.EXPO_PUBLIC_FRUITFUL_ENV,
    API_URL: 'https://api.fruitful.com',
    STYTCH_PUBLIC_TOKEN:
        'public-token-live-3ac561af-1dd0-4c54-877b-30f2ec8a94d7',
    STYTCH_ORGANIZATION_ID:
        'organization-live-28002902-6f63-4984-806b-b15c223d4d08',
    SENDBIRD_APP_ID: 'E8C8BD08-878B-4D82-9CDF-22A30C1D27CA',
    SENTRY_DSN:
        'https://20370c84e1e59e8b6a8c08613f61db0c@o4505363795738624.ingest.us.sentry.io/4507765036744704',
    MIXPANEL_TOKEN: 'cff2744326cfe6bc0f7c170245323f9e',
    LLM_SERVICE_BASE_URL: 'https://llm.fruitful.com',
};
